module.exports = __webpack_public_path__ + "static/img/logo.a67b35e.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/graphics/logo.svg
// module id = PRji
// module chunks = 1